import {
  SectionedHeader,
  SectionedHorizontalLinedTable,
  SwitchAppButton,
} from "../../../components";
import {
  HookFormCheckbox,
  HookFormRadioButton,
  HookFormSelect,
  SubmitButton,
} from "../../../hook-form";
import { IHookForm, IPayoutSettings } from "../../../interfaces-and-types";

export const View = ({
  formValues,
  goBack,
  isDirty,
  handleSubmit,
  errors,
  register,
}: IHookForm<IPayoutSettings> & {
  formValues: IPayoutSettings;
  goBack: () => void;
  isDirty: boolean;
}) => {
  console.log(
    "formValues.settle_collections_to_wallet: ",
    formValues.settle_collections_to_wallet
  );
  console.log(
    "Boolean(formValues.settle_collections_to_wallet): ",
    Boolean(formValues.settle_collections_to_wallet)
  );

  // console.log(
  //   "Boolean(formValues.enable_automatic_payout): ",
  //   Boolean(formValues.enable_automatic_payout)
  // );
  return (
    <form onSubmit={handleSubmit}>
      <SectionedHorizontalLinedTable>
        <SectionedHeader
          hasBorder={true}
          mainHead="Payout settings"
          subHead=""
        />

        <div
          style={{ backgroundColor: "#EDEBEB80", padding: "30px", gap: "20px" }}
          className="flex-container col"
        >
          <div className="payout-settings--container">
            {/* <HookFormToggle
              name="include_payment_gateways_and_methods"
              label="Show payment providers on checkout page"
              labelRight
              labelOff="No"
              labelOn="Yes"
              defaultToggled={show_payment_providersFormValue}
              onToggle={onToggleShowPaymentProviders}
              containerClassName="settings-toggle"
              infoIconText={
                <>
                  Payment providers will be displayed along with the default
                  card checkout view
                  <br />
                  <hr />
                  Users can pay via any of the enabled payment methods from
                  enabled providers.
                </>
              }
              register={register}
              errors={errors}
            /> */}

            <HookFormCheckbox
              name="settle_collections_to_wallet"
              label="Settle Collections To Wallet"
              containerClassName="settings-checkbox"
              infoIconText={
                formValues.settle_collections_to_wallet ? (
                  <>
                    All received payments will be settled to your wallet. You
                    may transfer it out manually at any time.
                  </>
                ) : (
                  <>
                    All received payments will be settled to your designated
                    payout bank account numbers.
                  </>
                )
              }
              register={register}
              errors={errors}
            />

            {/* <HookFormRadioButton
              name="settle_collections_to_wallet"
              label="Settle Collections To Wallet"
              orientation="vertical"
              defaultSelected={`${formValues.settle_collections_to_wallet}`}
              valueSelected={`${formValues.settle_collections_to_wallet}`}
              // checked={formValues.settle_collections_to_wallet}
              items={[
                {
                  text: "Settle Collections To Wallet",
                  value: "true",
                },
                {
                  text: "Settle Collections To Bank Account",
                  value: "false",
                },
              ]}
              isBooleanValue
              containerClassName="settings-checkbox"
              // infoIconText="xxxxxx"
              register={register}
              errors={errors}
            /> */}

            {/* <div className="flex-container align-items--start row">
              <HookFormRadioButton
                name="enable_automatic_payout"
                label="Enable Automatic Payout"
                orientation="vertical"
                defaultSelected={`${formValues.enable_automatic_payout}`}
                valueSelected={`${formValues.enable_automatic_payout}`}
                items={[
                  {
                    text: "Automatic",
                    value: "true",
                  },
                  {
                    text: "Manual",
                    value: "false",
                  },
                ]}
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                disabled={Boolean(formValues.settle_collections_to_wallet)}
                register={register}
                errors={errors}
              />

              <HookFormSelect
                name="automatic_payout_after_days"
                label=""
                containerClassName="settings-select"
                selectItems={[
                  {
                    text: "Daily",
                    value: 1,
                  },
                  {
                    text: "Weekly",
                    value: 7,
                  },
                  {
                    text: "Monthly",
                    value: 30,
                  },
                  {
                    text: "Yearly",
                    value: 365,
                  },
                ]}
                disabled={
                  !Boolean(formValues.settle_collections_to_wallet) ||
                  Boolean(formValues.enable_automatic_payout)
                }
                register={register}
                errors={errors}
              />
            </div> */}
          </div>
        </div>
        <div>
          <div
            style={{ margin: "10px" }}
            className="flex-container justify-content--end align-items--end"
          >
            <div className="button-group">
              <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
                Cancel
              </SwitchAppButton>

              <SubmitButton
                size="sm"
                // disabled={!isDirty}
                showChildrenWithLoadingIcon
              >
                Save
              </SubmitButton>
            </div>
          </div>
        </div>
      </SectionedHorizontalLinedTable>
    </form>
  );
};
